import _ from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import DropdownItem from "react-bootstrap/DropdownItem";
import Tab from "react-bootstrap/Tab";
import { useIntl } from "react-intl";
import * as uuid from "uuid";
import { CHART_MODE_CHART, CHART_MODE_TABLE, NUMBER, TOTAL } from "../../../../../ducks/collapsibleTableChart";
import { QuestionIcon } from "../../../../../utils/QuestionUtils";
import {
    getObjectFromList,
    getSubQuestionModifiedId,
    isTypeRelevant,
    transformStaticTableDataForChart
} from "../../../../../utils/TableUtils";
import CollapsibleCardHeader from "../CollapsibleCardHeader";
import HorizontalTable from "../HorizontalTable";
import CSVTypeQuestion from "./CSVTypeQuestion";
import NumberQuestion from "./NumberQuestion";

const StaticTableQuestion = ({
                                 table,
                                 details,
                                 expandedQuestionList,
                                 percentage,
                                 pivotShortcut,
                                 sinceBeginning,
                                 staticTables,
                                 getActiveTabStatic,
                                 label,
                                 notExpandableArray,
                                 optionsArray,
                                 collapsibleTablesDetails,
                                 csvQuestionDetails,
                                 modalSelectParameters,
                                 status,
                                 renderHeader,
                                 renderChart,
                                 onStaticTableModeChange,
                                 handleClickDownloadPivotQuestion,
                                 handleModalOpen,
                                 handlePivotShortcutSubmit,
                                 handleBeginningClick,
                                 handlePercentageClick,
                                 getQuestionPath,
                                 getBreadcrumbPath,
                                 renderPivotBreadcrumb,
                                 tabActive,
                                 onTabClick
                             }) => {
    const [chartMode, setChartMode] = useState({});
    const intl = useIntl();

    const handleSelectChartMode = (identifier) => {
        let tmp = _.cloneDeep(chartMode);
        tmp[identifier] = CHART_MODE_CHART;
        setChartMode(tmp);
    };

    const handleSelectTableMode = (identifier) => {
        let tmp = _.cloneDeep(chartMode);
        tmp[identifier] = CHART_MODE_TABLE;
        setChartMode(tmp);
    };

    const renderStaticSubquestionRows = (table, cols, renderSimpleTable) => {
        let headers = [];
        let contents = [];

        table.anwser.anwserList.forEach((column, index) => {
            const subquestionType = column.anwserList[0].questionType;
            let identifier;
            let colId;
            let rowId;
            if (column && column.anwserList[0].tableIdentifier) {
                colId = column.anwserList[0].tableIdentifier.colId;
                rowId = column.anwserList[0].tableIdentifier.rowId;
                if (cols) {
                    identifier = column.anwserList[0].tableIdentifier.columnKey
                        ? column.anwserList[0].tableIdentifier.columnKey
                        : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
                } else {
                    identifier = column.anwserList[0].tableIdentifier.rowKey
                        ? column.anwserList[0].tableIdentifier.rowKey
                        : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
                }
            }

            const subquestionModifiedId = getSubQuestionModifiedId(table.questionId, identifier, rowId, colId);
            const detailsShown = getObjectFromList(collapsibleTablesDetails, subquestionModifiedId);
            const parameters = modalSelectParameters[subquestionModifiedId];

            const title = column.title !== ""
                ? column.title
                : intl.formatMessage({id: "survey.editor.toolbox.staticTable.unnamed"});
            headers.push(
                subquestionType !== TOTAL && (
                    <DropdownItem
                        key={subquestionModifiedId}
                        eventKey={subquestionModifiedId}
                        active={getActiveTabStatic(table, cols) === subquestionModifiedId}
                        onClick={() => {
                            if (tabActive !== subquestionModifiedId) {
                                onTabClick(subquestionModifiedId);
                            }
                        }}
                    >
                        {isTypeRelevant(subquestionType, notExpandableArray)
                            ? null
                            : renderHeader(
                                detailsShown,
                                title,
                                subquestionType,
                                subquestionModifiedId
                            )}
                    </DropdownItem>
                )
            );
            const headTitle = <span><QuestionIcon type={subquestionType} /> {title}</span>;
            contents.push(
                subquestionType !== TOTAL && (
                    <Tab.Pane key={subquestionModifiedId} eventKey={subquestionModifiedId}>
                        <Card>
                            <Card.Header>
                                <CollapsibleCardHeader
                                    data={column.anwserList[0]}
                                    baseQuestionId={table.questionId}
                                    baseQuestionColId={cols ? colId : null}
                                    baseQuestionRowId={cols ? null : rowId}
                                    baseQuestionTitle={column.title}
                                    baseQuestionIdentifier={identifier}
                                    shortcutType={pivotShortcut[subquestionModifiedId]?.shortcutType}
                                    baseColumnType={subquestionType}
                                    isSubquestion={true}
                                    baseQuestionType={table.questionType}
                                    baseQuestionKey={table?.questionKey}
                                    baseQuestionRowKey={column.anwserList[0]?.tableIdentifier?.rowKey}
                                    baseQuestionColumnKey={column.anwserList[0]?.tableIdentifier?.columnKey}
                                    baseQuestionGroupKey={""}
                                    chartMode={chartMode[subquestionModifiedId]}
                                    handleClickDownloadQuestion={handleClickDownloadPivotQuestion}
                                    handleModalOpen={handleModalOpen}
                                    handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                                    handleSelectChartModeTable={() => handleSelectTableMode(subquestionModifiedId)}
                                    handleSelectChartModeChart={() => handleSelectChartMode(subquestionModifiedId)}
                                    onBeginningClick={handleBeginningClick}
                                    onPercentageClick={handlePercentageClick}
                                    baseQuestionString={getQuestionPath(table.questionTitle, column.title)}
                                    groupByQuestionString={detailsShown ? getBreadcrumbPath(subquestionModifiedId) : ""}
                                    percentageOn={percentage}
                                    checked={sinceBeginning[table.questionId] ? sinceBeginning[table.questionId] : false}
                                    status={status}
                                    key={uuid.v4()}
                                    periodCount={table.periodCount}
                                    renderBreadcrumb={!!detailsShown}
                                    onRenderBreadcrumb={() => renderPivotBreadcrumb(subquestionModifiedId)}
                                    columns={headers}
                                />
                            </Card.Header>
                            <Card.Body>
                                {!chartMode[subquestionModifiedId] || chartMode[subquestionModifiedId] === CHART_MODE_TABLE
                                    ? renderStaticSubquestionRowsTable(
                                        table,
                                        column,
                                        detailsShown,
                                        subquestionType,
                                        detailsShown
                                            ? pivotShortcut[subquestionModifiedId]?.pivotShortcut
                                                ? pivotShortcut[subquestionModifiedId].pivotShortcut
                                                : headTitle
                                            : headTitle,
                                        subquestionModifiedId,
                                        renderSimpleTable,
                                        parameters?.groupByColumnKey
                                    )
                                    : renderChart(
                                        detailsShown ? column.anwserList[0] : transformStaticTableDataForChart(
                                            column.anwserList),
                                        detailsShown,
                                        subquestionType,
                                        parameters?.groupByColumnName,
                                        parameters?.groupByColumnKey
                                    )}
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                )
            );
        });

        return (
            <Tab.Container activeKey={getActiveTabStatic(table, cols)}>
                <Tab.Content>{contents.map((elem) => elem)}</Tab.Content>
            </Tab.Container>
        );
    };

    const renderStaticSubquestionRowsTable = (
        table,
        column,
        detailsShown,
        subquestionType,
        firstColumnTitle,
        tableId,
        renderSimpleTable,
        groupByColumnKey
    ) => {
        return (
            <>
                {subquestionType === NUMBER ? (
                    <NumberQuestion
                        table={column.anwserList}
                        percentage={percentage[tableId]}
                        detailsShown={detailsShown}
                        staticTableCols={true}
                        firstColumnTitle={firstColumnTitle}
                        tableId={tableId.toString()}
                        renderSimpleTable={renderSimpleTable}
                    />
                ) : isTypeRelevant(subquestionType, notExpandableArray) ? (
                    <CSVTypeQuestion
                        table={table}
                        subquestion={column.anwserList[0]}
                        subQuestionTitle={column.anwserList[0].title}
                        csvQuestionDetails={csvQuestionDetails}
                        modalSelectParameters={modalSelectParameters}
                        status={status}
                        label={label}
                        percentage={percentage}
                        renderChart={renderChart}
                        renderPivotBreadcrumb={renderPivotBreadcrumb}
                        handleClickDownloadPivotQuestion={handleClickDownloadPivotQuestion}
                        handleModalOpen={handleModalOpen}
                        handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                        handleBeginningClick={handleBeginningClick}
                        handlePercentageClick={handlePercentageClick}
                        getQuestionPath={getQuestionPath}
                        getBreadcrumbPath={getBreadcrumbPath}
                        pivotShortcut={pivotShortcut}
                        sinceBeginning={sinceBeginning}
                    />
                ) : isTypeRelevant(subquestionType, optionsArray) ? (
                    <HorizontalTable
                        data={column.anwserList[0]}
                        percentage={percentage[tableId]}
                        tableId={`table_${tableId}`}
                        subQuestionDetails={detailsShown}
                        key={uuid.v4()}
                        firstColumnTitle={firstColumnTitle}
                        useZAxisValue={groupByColumnKey === "project"}
                    />
                ) : null}
            </>
        );
    };

    const renderStaticSubquestionCols = (table, intl) => {
        const rowCnt = table.anwser.anwserList.length;
        const colCnt = table.anwser.anwserList[0].anwserList.length;
        let invertedArray = [];
        let newTable = JSON.parse(JSON.stringify(table));

        // swap cols and rows
        for (let cols = 0; cols < colCnt; cols++) {
            invertedArray[cols] = {
                compositeType: table.anwser.anwserList[0].anwserList[cols].compositeType,
                title:
                    table.anwser.anwserList[0].anwserList[cols].title !== ""
                        ? table.anwser.anwserList[0].anwserList[cols].title
                        : intl.formatMessage({id: "survey.editor.toolbox.staticTable.unnamed"})
            };
            invertedArray[cols].anwserList = [];
            for (let rows = 0; rows < rowCnt; rows++) {
                let newObj = _.cloneDeep(table.anwser.anwserList[rows].anwserList[cols]);
                if (newObj) {
                    newObj.title = table.anwser.anwserList[rows].title;
                    invertedArray[cols].anwserList[rows] = newObj;
                }
            }
        }

        newTable.anwser.anwserList = invertedArray;

        return renderStaticSubquestionRows(newTable, true, true);
    };

    return (
        <>
            <ButtonGroup>
                <Button
                    className={"rounded-0 border-start border-top border-bottom-0 border-end-0 shadow-none"}
                    variant="outline-secondary"
                    active={!staticTables[table.questionId] || staticTables[table.questionId] === "col"}
                    onClick={() => onStaticTableModeChange(table.questionId, "col")}
                >
                    {intl.formatMessage({id: "question.library.language.staticTable.cols"})}
                </Button>
                <Button
                    className={"rounded-0 border-start-0 border-top border-bottom-0 border-end shadow-none"}
                    variant="outline-secondary"
                    active={staticTables[table.questionId] === "row"}
                    onClick={() => onStaticTableModeChange(table.questionId, "row")}
                >
                    {intl.formatMessage({id: "question.library.language.staticTable.rows"})}
                </Button>
            </ButtonGroup>
            {staticTables && staticTables[table.questionId] && staticTables[table.questionId] === "row"
                ? expandedQuestionList.includes(table.questionId) &&
                table.anwser.anwserList.length > 0 &&
                renderStaticSubquestionRows(table, false, true)
                : expandedQuestionList.includes(table.questionId) &&
                table.anwser.anwserList.length > 0 &&
                renderStaticSubquestionCols(table, intl)}
        </>
    );
};

StaticTableQuestion.propTypes = {
    table: PropTypes.object,
    details: PropTypes.bool,
    expandedQuestionList: PropTypes.array,
    percentage: PropTypes.array,
    pivotShortcut: PropTypes.array,
    sinceBeginning: PropTypes.object,
    staticTables: PropTypes.array,
    getActiveTabStatic: PropTypes.func,
    label: PropTypes.array,
    notExpandableArray: PropTypes.array,
    optionsArray: PropTypes.array,
    collapsibleTablesDetails: PropTypes.array,
    csvQuestionDetails: PropTypes.array,
    modalSelectParameters: PropTypes.array,
    status: PropTypes.string,
    renderHeader: PropTypes.func,
    renderChart: PropTypes.func,
    onStaticTableModeChange: PropTypes.func,
    handleClickDownloadPivotQuestion: PropTypes.func,
    handleModalOpen: PropTypes.func,
    handlePivotShortcutSubmit: PropTypes.func,
    handleBeginningClick: PropTypes.func,
    handlePercentageClick: PropTypes.func,
    getQuestionPath: PropTypes.func,
    getBreadcrumbPath: PropTypes.func,
    renderPivotBreadcrumb: PropTypes.func,
    intl: PropTypes.object
};

export default StaticTableQuestion;
